// extracted by mini-css-extract-plugin
export default {"linkWrapper":"Footer_linkWrapper__B1JWz"};